import { FormattedServiceTemplateDetails } from "@idw-types/data/service-template-details/service-template-details";

export enum ServiceTemplateDetailsActionTypes {
    SET_SERVICE_TEMPLATE_DETAILS_LOADING = "SET_SERVICE_TEMPLATE_DETAILS_LOADING",
    SET_SERVICE_TEMPLATE_DETAILS = "SET_SERVICE_TEMPLATE_DETAILS"
}

type SetServiceTemplateDetailsLoadingAction = {
    type: ServiceTemplateDetailsActionTypes.SET_SERVICE_TEMPLATE_DETAILS_LOADING,
    payload: { isLoading: boolean; }
};

export const setServiceTemplateDetailsLoading = (isLoading: boolean): SetServiceTemplateDetailsLoadingAction => ({
    type: ServiceTemplateDetailsActionTypes.SET_SERVICE_TEMPLATE_DETAILS_LOADING,
    payload: { isLoading }
});

type SetServiceTemplateDetailsAction = {
    type: ServiceTemplateDetailsActionTypes.SET_SERVICE_TEMPLATE_DETAILS,
    payload: { serviceTemplate: FormattedServiceTemplateDetails; }
}

export const setServiceTemplateDetails = (serviceTemplate: FormattedServiceTemplateDetails): SetServiceTemplateDetailsAction => ({
    type: ServiceTemplateDetailsActionTypes.SET_SERVICE_TEMPLATE_DETAILS,
    payload: { serviceTemplate }
});

export type ServiceTemplateDetailsActions =
    SetServiceTemplateDetailsLoadingAction |
    SetServiceTemplateDetailsAction;
     